import { SYSTEM_MAIL_TYPES, SYSTEM_VARIABLE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import { schemaSystemVariableCommon } from './systemVariableCommon';

export const schemaSystemMails = z
    .object({
        property: z.array(z.nativeEnum(SYSTEM_MAIL_TYPES)),
        type: z.literal(SYSTEM_VARIABLE_TYPES.SYSTEM_MAILS),
    })
    .merge(schemaSystemVariableCommon);
